// extracted by mini-css-extract-plugin
module.exports = {"LinkedinLogo":"LinkedinLogo_LinkedinLogo__1ui62"};